import React from 'react';
import { connect } from 'react-redux'
import { Tree } from 'antd';
import { WikiActions } from '../../redux';

const { TreeNode } = Tree;

class WikiSelectPage extends React.Component {
  state = {
    treeData: [
      { title: 'NODE0', key: '0' },
      { title: 'NODE1', key: '1', isLeaf: true },
    ],
  };

  onLoadData = treeNode =>
    new Promise(resolve => {
      if (treeNode.props.children) {
        resolve();
        return;
      }
      this.props.dispatch(WikiActions.loadNodePages(treeNode.props.dataRef.nodeId))
      .then(response => {
        console.log("result", response);
        this.setState({sub:response});
        resolve();
        return;
      })
    });

  renderTreeNodes = data =>
    data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={(item.name)?item.name:item.title} key={item.uuid} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode title={(item.name)?item.name:item.title} key={item.uuid} dataRef={item} />;
    });

  onSelect = (selectedKeys, info) => {
    //console.log('selected', selectedKeys, info);
    if (this.props.onSelect){
      this.props.onSelect(selectedKeys, info)
    }
    this.props.dispatch(WikiActions.SELECTED(info.node.props.dataRef));
  };

  render() {
    //console.log(this);
    return <Tree  onSelect={this.onSelect} loadData={this.onLoadData}>{this.renderTreeNodes(this.props.nodes)}</Tree>;
  }
}

export default connect(
  (state, props) => {
    const {vset, lwiki} = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      nodes: (lwiki.nodes)?lwiki.nodes:[],
    })
  },
  null //dispatch => ({})
)(WikiSelectPage)
